export const POST_METHOD_CREDIT_API = "POST_METHOD_CREDIT_API"
export const POST_METHOD_CREDIT_API_SUCCESS = "POST_METHOD_CREDIT_API_SUCCESS"

export const GET_CREDIT_LIST = "GET_CREDIT_LIST"
export const GET_CREDIT_LIST_SUCCESS = "GET_CREDIT_LIST_SUCCESS"

export const DELETE_CREDIT_LIST_ID = "DELETE_CREDIT_LIST_ID"
export const DELETE_CREDIT_LIST_ID_SUCCESS = "DELETE_CREDIT_LIST_ID_SUCCESS"

export const BULK_CREDITNOTE_DELETE_ID = "BULK_CREDITNOTE_DELETE_ID"
export const BULK_CREDITNOTE_DELETE_ID_SUCCESS = "BULK_CREDITNOTE_DELETE_ID_SUCCESS"

export const CREDITDEBIT_TYPE = "CREDITDEBIT_TYPE"
export const CREDITDEBIT_TYPE_SUCCESS = "CREDITDEBIT_TYPE_SUCCESS"

export const EDIT_CREDIT_LIST_ID = "EDIT_CREDIT_LIST_ID"
export const EDIT_CREDIT_LIST_ID_SUCCESS = "EDIT_CREDIT_LIST_ID_SUCCESS"

export const INVOICE_RETURN_ID = "INVOICE_RETURN_ID"
export const INVOICE_RETURN_ID_SUCCESS = "INVOICE_RETURN_ID_SUCCESS"

export const SAVE_CREDIT = "SAVE_CREDIT"
export const SAVE_CREDIT_SUCCESS = "SAVE_CREDIT_SUCCESS"

export const RECEIPT_NUMBER_LIST = "RECEIPT_NUMBER_LIST"
export const RECEIPT_NUMBER_LIST_SUCCESS = "RECEIPT_NUMBER_LIST_SUCCESS"


//**************************** E-Invoice- Credit-Debit (upload ,cancel,print) ***************************************/

export const UPLOADED_CREDIT_DEBIT_E_INVOICE_ACTION = 'UPLOADED_CREDIT_DEBIT_E_INVOICE_ACTION'
export const UPLOADED_CREDIT_DEBIT_E_INVOICE_ACTION_SUCCESS = 'UPLOADED_CREDIT_DEBIT_E_INVOICE_ACTION_SUCCESS'

export const CANCLE_CREDIT_DEBIT_E_INVOICE_ACTION = 'CANCLE_CREDIT_DEBIT_E_INVOICE_ACTION'
export const CANCLE_CREDIT_DEBIT_E_INVOICE_ACTION_SUCCESS = 'CANCLE_CREDIT_DEBIT_E_INVOICE_ACTION_SUCCESS'

export const CREDIT_DEBIT_API_ERROR_ACTION = "CREDIT_DEBIT_API_ERROR_ACTION"


